import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ColDef, ColGroupDef } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { API_URL } from 'src/app/app.contant';
import { IAPIResponse, IBuyerData, IMaterialMaster, IPurchaseRequest } from '../../shared/models';
import { ISupplierMarketResult } from '../models';
import { EncryptionService } from '../../dashboard/services/encryption.service';

@Injectable({
  providedIn: 'root'
})
export class PrBuyerDashboardService {

  constructor(private http: HttpClient, private _encryptionService:EncryptionService) { }

  public getColumnDefs(): (ColDef | ColGroupDef)[] {
    const coldefs = [
      {
        groupId: 'prGroup',
        headerName: 'PR Data',
        children: [
          { headerName: 'PR #', field: 'prNumber', pinned: 'left', resizable: true, filter: true, checkboxSelection: true, headerCheckboxSelection: true, columnGroupShow: 'open' },
          {
            headerName: 'Submission Date', field: 'submissionDate', pinned: 'left', resizable: true, filter: true, columnGroupShow: 'closed', cellRenderer: (data: any) => {
              return data.value ? (new Date(data.value)).toLocaleDateString() : '';
            }
          },
          { headerName: 'Reference #', field: 'referenceNo', pinned: 'left', resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'Aging', field: 'aging', pinned: 'left', resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'PR Category', field: 'prCategory', pinned: 'left', resizable: true, filter: true, columnGroupShow: 'closed' }
        ],
      },
      {
        groupId: 'basicDetails',
        headerName: 'Metadata',
        children: [
          { headerName: 'Purchasing Organization', field: 'purchazingOrganization', resizable: true, filter: true, columnGroupShow: 'open' },
          { headerName: 'Currency', field: 'currency', resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'Line Item #', field: 'lineItem', resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'Account Assignment Category', field: 'accountAssignmentCategory', resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'Item Category', field: 'itemCategory', resizable: true, filter: true, columnGroupShow: 'closed' }
        ],
      },
      {
        groupId: 'prActionGroup',
        headerName: '',
        children: [
          { headerName: 'PR Validation Status', pinned: 'right', field: 'prValidationStatus', resizable: true, filter: true },
          { headerName: 'Validation Remarks', field: 'validationRemarks', resizable: true, filter: true, pinned: 'right', },
          {
            headerName: 'Actions', pinned: 'right', resizable: true, filter: true,
            cellRenderer: 'AgGridActionsRendererComponent',
            cellRendererParams: [
              { name: "View PR", icon: "fa-eye" },
              { name: "Edit PR", icon: "fa-edit" },
              { name: "Forward Request", icon: "fa-forward" },
              { name: "Approve/Reject", icon: "fa-check" }],
            cellEditor: 'AgGridActionsWrapperComponent',
            cellEditorPopup: true,
            singleClickEdit: true,
            editable: true,
          },
        ],
      }
    ];
    return coldefs;
  }

  public getBuyerData(): Observable<IAPIResponse<Array<any>>> {
    return this.http.get<IAPIResponse<Array<any>>>(`${API_URL.BUYER.FETCH_BUYERS}`);
  }

 

  public runMRP(ipDetails: { ip_plant: any, ip_mrp_controller: any }): Observable<IAPIResponse<any>> { //IP_PLANT=9E62&IP_MRP_CONTROLLER=EN3
    return this.http.get<IAPIResponse<any>>(`${API_URL.BUYER.RUN_MRP}IP_PLANT=${this._encryptionService.encryptPayload(ipDetails.ip_plant)}&IP_MRP_CONTROLLER=${this._encryptionService.encryptPayload(encodeURIComponent(ipDetails.ip_mrp_controller))}`);
  }

  public getMRPPRs(ipDetails:  any): Observable<IAPIResponse<any>> { //IP_PLANT=9E62&IP_MRP_CONTROLLER=EN3
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER.GET_MRP_PRS}`, ipDetails);
  }

  public getmrpFormData(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.BUYER.GET_MRP_FORMDATA}`);
  }

  public forwardLineItem(material_master: IMaterialMaster, buyerGid: string): Observable<IAPIResponse<Array<IBuyerData>>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER}${material_master.material_master_id}/${buyerGid}`, null);
  }

  public forwardPR(prId: any, buyer_id: string, remark: string): Observable<IAPIResponse<Array<IBuyerData>>> {
    let payload = {
      "prId": prId,
      "buyer_gid": buyer_id,
      "remarks":  remark
    }
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER.FORWARD_PR_TO_BUYER}`, payload);
  }

  public forwardPr(prDetails: IPurchaseRequest, buyerGid: string, remark: string): Observable<IAPIResponse<Array<IBuyerData>>> {
    let payload = {
      "prId": prDetails.prId,
      "forward_user_id": buyerGid,
      "remarks":  remark
    }
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER.FORWARD_PR}`, payload);
  }

  public updatePR(purchaseRequest: IPurchaseRequest): Observable<any> {
    return this.http.post<any>(`${API_URL.UPDATE_PR}`, purchaseRequest);
  }

  public addBuyerContractData(uploadedFile: FormData): Observable<any> {
    return this.http.post<any>(`${API_URL.UPLOAD_RC}`, uploadedFile);
  }

  // Supplier Market Assessment related APIs //////
  public fetchMarketResults(MaterialNumber: string, PURCH_ORG : string, COMP_CODE : string, DESCRIPTION : string) : Observable<IAPIResponse<ISupplierMarketResult[]>> {
    return this.http.post<any>(`${API_URL.BUYER.MARKET_RESULT.FETCH_RESULT}`, {MaterialNumber : [MaterialNumber], PURCH_ORG, COMP_CODE, DESCRIPTION});
  }

  public fetchMarketResultsforAllLineITems(MaterialNumber: any,serviceCodes:any, PURCH_ORG : string, COMP_CODE : string, DESCRIPTION : string, prId:any) : Observable<IAPIResponse<ISupplierMarketResult[]>> {
    console.log(prId)
    return this.http.post<any>(`${API_URL.BUYER.MARKET_RESULT.FETCH_RESULT}`, {MaterialNumber : MaterialNumber,ServiceNumber:serviceCodes, PURCH_ORG, COMP_CODE, DESCRIPTION,prId:prId});
  }
  
  public fetchVendorResults(vendorId: number, prId: any): Observable<IAPIResponse<Array<any>>> {
    return this.http.get<any>(`${API_URL.BUYER.MARKET_RESULT.FETCH_VENDOR}${this._encryptionService.encryptPayload(vendorId)}&pr_id=${this._encryptionService.encryptPayload(prId)}`);
  }

  public addVendorToLineitem(vendor: any): Observable<IAPIResponse<Array<any>>> {
    return this.http.post<any>(`${API_URL.BUYER.MARKET_RESULT.ADD_VENDOR}`, vendor);
  }

  public importPRDetails(importPRForm: any): Observable<IAPIResponse<Array<any>>> {
    return this.http.get<any>(`${API_URL.BUYER.IMPORT_PR}${this._encryptionService.encryptPayload(encodeURIComponent(importPRForm?.pr_number))}&material_no=${this._encryptionService.encryptPayload(encodeURIComponent(importPRForm?.material_number))}&plant_code=${this._encryptionService.encryptPayload(encodeURIComponent(importPRForm?.plant_code))}`);
  }

  public createPrFromSAP(prData: Array<any>): Observable<IAPIResponse<Array<any>>> {
    return this.http.post<any>(`${API_URL.BUYER.CREATE_PR_FROM_SAP}`, prData);
  }

}
